import { type ReactNode, useState } from 'react'
import { ReportFormContext } from './ReportFormContext'

type Props = {
  children: ReactNode
}

const ReportFormProvider = ({ children }: Props) => {
  const [victimPin, setVictimPin] = useState<string | null>(null)
  const [createdAt, setCreatedAt] = useState<Date | null>(null)
  const [tag, setTag] = useState<string | null>(null)
  const [isAnonymous, setIsAnonymous] = useState(true)

  return (
    <ReportFormContext.Provider
      value={{
        victimPin,
        setVictimPin,
        createdAt,
        setCreatedAt,
        tag,
        setTag,
        isAnonymous,
        setIsAnonymous,
      }}
    >
      {children}
    </ReportFormContext.Provider>
  )
}

export default ReportFormProvider
